import * as CONSTANTS from '../constants/constants';

export const getUsers = () => (
  dispatch,
  getState,
  { getFirestore }
) => {
  const firestore = getFirestore();
  const users = [];
  const usersRef = firestore.collection(CONSTANTS.USERS);

  usersRef.get().then((querySnapshot) => {
    querySnapshot.forEach((user) => {
      users.push(Object.assign(user.data(), { id: user.id }));
    });
    dispatch({ type: CONSTANTS.GET_USERS, users });
  }).catch((e) => {
    // eslint-disable-next-line no-console
    console.log('error', e);
  });
};

export const getStudents = () => (
  dispatch,
  getState,
  { getFirestore }
) => {
  const firestore = getFirestore();
  const students = [];
  const studentRef = firestore.collection(CONSTANTS.USERS);
  const findStudents = studentRef.where("role", "==", "student");

  findStudents.get().then((querySnapshot) => {
    querySnapshot.forEach((user) => {
      students.push(Object.assign(user.data(), { id: user.id }));
    });
    dispatch({ type: CONSTANTS.GET_STUDENTS, students });
  }).catch((e) => {
    // eslint-disable-next-line no-console
    console.log('error', e);
  });
};


export const getUser = userId => (
  dispatch,
  getState,
  { getFirestore }
) => {
  // console.log(userId)
  const firestore = getFirestore();
  const userRef = firestore.collection(CONSTANTS.USERS).doc(userId);

  userRef.get().then((snapshot) => {
    const user = Object.assign(snapshot.data(), { id: snapshot.id });
    dispatch({ type: CONSTANTS.GET_USER, user });
  }).catch((e) => {
    // eslint-disable-next-line no-console
    console.log('error', e);
  });
};


export const getUserAndAddCourse = courseId => (
  dispatch,
  getState,
  { getFirebase, getFirestore }
) => {
  const firebase = getFirebase();
  const firestore = getFirestore();
  const user = firebase.auth().currentUser;
  if (user !== null) {
    const userRef = firestore.collection(CONSTANTS.USERS).doc(user.uid);
    const coursespoolRef = userRef.collection('coursespool')
    let coursespool = []
    coursespoolRef.get().then((querySnapshot) => {
      querySnapshot.forEach((course) => {
        coursespool.push(Object.assign(course.data(), { uid: course.id }));
      });
      var checkCoursespool = []
      checkCoursespool = coursespool.filter((course) => {
        return course.courseId === courseId
      })
      if(!checkCoursespool.length) {
        coursespoolRef.add({
          courseId
        })
      }
    })
  }
};
